import * as Sentry from "@sentry/browser";
import { size } from "lodash-es";
import { createAsyncAction, errorResult, successResult } from "pullstate";
import { TokenList, fetchTokenList } from "../global/getAllTokenLists";
import { ActivityStore } from "./ActivityStore";
import { SUPPORTED_CHAINS } from "config/chains";

// Tokens from all chains are amalgamated into one object
export const fetchAllTokensInclInactiveTokens = (): Promise<TokenList> => {
  return Promise.allSettled(SUPPORTED_CHAINS.map(chain => fetchTokenList(chain.id, true))).then(
    results => {
      const tokens: TokenList = {};
      (
        results.filter(result => result.status === "fulfilled") as unknown as Array<
          PromiseFulfilledResult<TokenList>
        >
      )
        .map(result => result.value)
        .forEach(result => {
          Object.assign(tokens, result);
        });
      return tokens;
    }
  );
};

/* The point of retrieving the data from ALL /tokens endpoints is due to us having listed tokens on some networks and not others
 *  1. We need the tokens decimals in order to format values
 *  2. We also need the metadata for the token
 * */
export const getAllTokenListsInclInactiveTokens = createAsyncAction(
  async () => {
    try {
      const result = await fetchAllTokensInclInactiveTokens();
      if (result) {
        return successResult(result);
      }
      throw new Error("Result is falsy");
    } catch (e) {
      console.log(e);
      const errorMsg = "Could not get all token lists (incl. inactive tokens)";
      Sentry.captureException(errorMsg, { extra: { event: e } });
      return errorResult([], errorMsg, e);
    }
  },
  {
    postActionHook: ({ result }) => {
      if (!result.error) {
        ActivityStore.update(s => {
          if (size(result.payload) === 0) {
            console.log(`Got an empty response from the Tokens endpoint - dropping it`);
            Sentry.captureException(`tokens endpoint returned an empty response`);
            return null; // undefined for loading / not fetched yet, payload for fetched results and null for fetched but no results.
          }
          // s.tokens = result.payload;
        });
      }
    },
  }
);
